<template>
    <div class="centered">Your session expired. Please reload the window.</div>
</template>

<script>
export default {};
</script>

<style>
.centered {
    padding: 50px 20px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// LoggedOut.vue?11dd725d